import {IMAGE_TYPE} from './mediaType';

export const CHECKIN_INDEX = `
  date
  id
  status
`;